<template>
  <i-header />
  <div class="index-nav">
    <van-button
      round
      color="#3eaaf7"
      icon="plus"
      size="small"
      type="primary"
      @click="
        $router.push({
          name: 'Create',
        })
      "
      >新建工单</van-button
    >
    <van-badge :dot="filtered">
      <van-button
        round
        color="#3eaaf7"
        icon="apps-o"
        size="small"
        type="primary"
        @click="show = true"
      >
        筛选</van-button
      >
    </van-badge>
  </div>

  <van-tabs
    v-model:active="formData.list_type"
    type="card"
    @click="handleClick"
    color="#3eaaf7"
    background="#fff"
  >
    <van-tab title="全部报修" name="3" v-if="!power('1-1-3')">
      <van-tabs
        v-model:active="formData.progre_state"
        @click="handleClick"
        sticky
        color="#3eaaf7"
      >
        <van-tab
          v-for="type in state.types"
          :title="type.title"
          :name="type.value"
          :key="type.value"
        >
        </van-tab>
      </van-tabs>
    </van-tab>
    <van-tab title="我的接单" name="1" v-if="power('1-6')">
      <van-tabs
        v-model:active="formData.repair_state"
        @click="handleClick"
        sticky
        color="#3eaaf7"
      >
        <van-tab
          v-for="type in state.repairTypes"
          :title="type.title"
          :name="type.value"
          :key="type.value"
        >
        </van-tab>
      </van-tabs>
    </van-tab>
    <van-tab title="待接单" name="2" v-if="power('1-6')"></van-tab>
    <van-tab title="我的报修" name="4"></van-tab>
    <van-tab title="部门报修" name="5" v-if="power('1-1-1')"></van-tab>
    <van-tab title="我的退删" name="6" v-if="!power(['1-14', '1-15'])">
      <van-tabs
        v-model:active="formData.ignore_state"
        @click="handleClick"
        sticky
        color="#3eaaf7"
      >
        <van-tab
          v-for="type in state.ignoreType"
          :title="type.title"
          :name="type.value"
          :key="type.value"
        >
        </van-tab>
      </van-tabs>
    </van-tab>
  </van-tabs>
  <van-pull-refresh v-model="state.refreshing" @refresh="onRefresh">
    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      @load="getRepairList"
    >
      <div>
        <van-cell-group
          style="margin: 10px 0"
          v-for="repair in state.list"
          :key="repair.id"
          @click="toDetail(repair)"
        >
          <van-cell center title="" :value="repair.fault_time_name">
            <template #icon>
              <van-tag
                size="medium"
                style="margin-right: 10px"
                :color="colors[repair.progre_state - 1]"
                text-color="#fff"
                >{{ repair.progre_state_name }}</van-tag
              >
              <van-tag
                size="medium"
                :color="colors[repair.rlevel - 1]"
                text-color="#fff"
                >{{ repair.rlevel_name }}</van-tag
              >
            </template>
          </van-cell>
          <van-cell :title="`编号：${repair.order_code}`" />
          <van-cell :title="`报修人：${repair.fault_name}`" />
          <van-cell center :title="`位置：${repair.place_name}`"> </van-cell>
          <van-cell :value="repair.fault_note" />
        </van-cell-group>
      </div>
      <template #finished>
        <van-empty v-if="state.list.length === 0" description="没有更多了" />
        <template v-else> 没有更多了 </template>
      </template>
    </van-list>
  </van-pull-refresh>
  <!-- 弹出框 -->
  <repair-filter v-model:show="show" @confirm="onConfirm" />
</template>
<script>
import { computed, reactive, ref } from "vue";
import { repairService } from "@/service";
import RepairFilter from "./components/RepairFilter.vue";
import moment from "moment";
import { useRoute, useRouter } from "vue-router";
import { usePower } from "@/hooks";
import { Toast } from "vant";
export default {
  name: "Index",
  components: {
    RepairFilter,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const { power } = usePower();
    // list
    const colors = ["#3eaaf7", "#ff9800", "#ff5722", "#4caf50", "#9e9e9e"];
    const state = reactive({
      refreshing: false,
      list: [],
      repairTypes: [
        {
          title: "未修好",
          value: "1",
        },
        {
          title: "已修好",
          value: "2",
        },
      ],
      ignoreType: [
        {
          title: "已删工单",
          value: "2",
        },
        {
          title: "已退工单",
          value: "3",
        },
      ],
      types: [
        {
          title: "全部",
          value: "",
        },
        {
          title: "未派修",
          value: "1",
        },
        {
          title: "维修中",
          value: "2",
        },
        {
          title: "待评价",
          value: "3",
        },
        {
          title: "待审核",
          value: "4",
        },
        {
          title: "已完结",
          value: "5",
        },
      ],
      loading: false,
      finished: false,
    });
    // 根据条件隐藏按钮
    if (power("1-1-5")) {
      state.types = state.types.filter((type) => type.value !== "3");
    }
    if (power("1-1-6")) {
      state.types = state.types.filter((type) => type.value !== "4");
    }

    const formData = reactive({
      repair_state: route.query.repairType,
      progre_state: route.query.tab,
      ignore_state: route.query.ignoreType,
      fault_time_start: "",
      fault_time_end: "",
      is_have_part: "",
      place_id: "",
      region_id: "",
      department_ids: "",
      keyword: "",
      page: 1,
      pagesize: 10,
      list_type: route.query.listType,
    });

    const filtered = computed(() => {
      return [
        "fault_time_start",
        "fault_time_end",
        "is_have_part",
        "place_id",
        "region_id",
        "department_ids",
        "keyword",
      ].some((key) => {
        return formData[key];
      });
    });
    const resetList = () => {
      formData.page = 1;
      state.list = [];
    };
    const getRepairList = async () => {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
        overlay: true,
        duration: 0,
      });
      try {
        if (state.refreshing) {
          resetList();
          state.refreshing = false;
        }

        const { data, total_number } =
          formData.list_type === "6"
            ? await repairService.ignoreList(formData.ignore_state, {
                ...formData,
                repair_state: "",
                progre_state: "",
              })
            : await repairService.repairList({
                ...formData,
                ignore_state: "",
                repair_state:
                  formData.list_type === "1" ? formData.repair_state : "",
                progre_state:
                  formData.list_type === "3" ? formData.progre_state : "",
              });

        state.list.push(...data);
        formData.page++;
        state.loading = false;
        if (state.list.length >= total_number) {
          state.finished = true;
        }
      } catch (error) {
        state.list = [];
        state.finished = true;
      }
      Toast.clear();
    };

    const handleClick = () => {
      router.replace({
        query: {
          repairType: formData.repair_state,
          listType: formData.list_type,
          tab: formData.progre_state,
          ignoreType: formData.ignore_state,
        },
      });
      resetList();
      getRepairList();
    };

    // 筛选
    const show = ref(false);
    const onConfirm = (res) => {
      if (res.calendar.length === 2) {
        formData.fault_time_start = moment(res.calendar[0]).format("X");
        formData.fault_time_end = moment(res.calendar[1]).format("X");
      }
      formData.region_id = res.place[0]?.id || "";
      formData.place_id = res.place[1]?.id || "";
      formData.department_ids = res.department;
      formData.is_have_part = res.isHavePart;
      formData.keyword = res.keyword;
      resetList();
      getRepairList();
    };

    // 刷新
    const onRefresh = () => {
      // 清空列表数据
      state.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      state.loading = true;
      getRepairList();
    };
    const toDetail = (value) => {
      router.push({
        name: "Detail",
        params: {
          id: value.id,
        },
      });
    };
    return {
      power,
      colors,
      state,
      handleClick,
      getRepairList,
      formData,
      show,
      onConfirm,
      toDetail,
      onRefresh,
      filtered,
    };
  },
};
</script>
<style lang="less" scoped>
.index-nav {
  background: #fff;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.repair-item {
  margin: 0 10px;
}
</style>
